<template>
  <v-item-group
    multiple
    :value="value"
    @change="$emit('input', $event)"
  >
    <reference-file-download-item
      v-if="hasRelevantReferences"
      classification="RELEVANT"
      :count="relevantCount"
      :review="review"
    />
    <reference-file-download-item
      v-if="hasNotRelevantReferences"
      classification="NOT_RELEVANT"
      :count="notRelevantCount"
      :review="review"
    />
    <reference-file-download-item
      v-if="hasNotSureReferences"
      classification="NOT_SURE"
      :count="notSureCount"
      :review="review"
    />
    <reference-file-download-item
      v-if="hasUnscreenedReferences"
      classification="UNSCREENED"
      :count="unscreenedCount"
      :review="review"
    />
  </v-item-group>
</template>

<script>
import ReferenceFileDownloadItem from './ReferenceFileDownloadItem';
import { Review } from '@/models';

export default {
  name: 'ReferenceFileDownloadList',
  components: { ReferenceFileDownloadItem },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    relevantCount: {
      type: Number,
      default: 0,
    },
    notRelevantCount: {
      type: Number,
      default: 0,
    },
    notSureCount: {
      type: Number,
      default: 0,
    },
    unscreenedCount: {
      type: Number,
      default: 0,
    },
    review: {
      type: Review,
      default: null,
    },
  },
  data: () => ({ selected: [] }),
  computed: {
    hasRelevantReferences() {
      return this.relevantCount !== 0;
    },
    hasNotRelevantReferences() {
      return this.notRelevantCount !== 0;
    },
    hasNotSureReferences() {
      return this.notSureCount !== 0;
    },
    hasUnscreenedReferences() {
      return this.unscreenedCount !== 0;
    },
  },
};
</script>
